import { Link } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

/**
 *
 * Link Component
 * @param {import("@mui/material").LinkProps} props
 * @returns {JSX.Element}
 */
const LinkComponent = (props) => {
  return (
    <Link {...props}>
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        {props.children || props.href}
        {props?.children || props.target === "_blank" ? (
          <OpenInNewIcon fontSize="8px" />
        ) : null}
      </div>
    </Link>
  );
};

export default LinkComponent;
